/**
 * @flow
 * @author: VaraKumar
 */

import React, { Component } from 'react'
import MobileTestimonialSection from '../../Home/TestimonialSection/MobileTestimonialSection'
import TabletTestimonialSection from '../../Home/TestimonialSection/TabletTestimonialSection'
import DesktopTestimonialSection from '../../Home/TestimonialSection/DesktopTestimonialSection'
import TestimonialTitle from './TestimonialTitle'
import TestimonialFooter from './TestimonialFooter'
import {
  isMobileDevice,
  isTabletDevice,
  isMediumDesktopDevice,
  isDesktopDevice
} from './responsiveUtils'
import {
  TestimonialSectionWrapper,
  TestimonialSectionContainer
} from './styledComponents'

class TestimonialSection extends Component {
  render() {
    return (
      <TestimonialSectionWrapper id="arcade-testimonials-section">
        <TestimonialTitle />
        <TestimonialSectionContainer>
          {isMobileDevice() ? <MobileTestimonialSection /> : null}
          {isTabletDevice() ? <TabletTestimonialSection /> : null}

          {isMediumDesktopDevice() ? <TabletTestimonialSection /> : null}
          {isDesktopDevice() ? <DesktopTestimonialSection /> : null}
          {isDesktopDevice() && <TestimonialFooter />}
        </TestimonialSectionContainer>
      </TestimonialSectionWrapper>
    )
  }
}

export default TestimonialSection



// WEBPACK FOOTER //
// ./src/components/IbcArcade/TestimonialSection/index.js